import createBaseService from "@/api/base-service.ts";
import type { CourtLevel } from "../../types/court-level";

const courtLevelService = {
	...createBaseService<CourtLevel>("/court-levels"),
};

export default courtLevelService;
